(function () {
  const elements = document.getElementsByClassName('article__wrapper')[0].getElementsByTagName('h2');
  const list = document.getElementById('indexList');
  const len = elements.length;
  let str = '';
  // h2を元にサイドメニューを作成
  for (let i = 0; i < len; i++){
    let num = i + 1;
    str = str + '<li><a href="#index'+ num +'">→ ' + elements.item(i).textContent + '</a></li>';
  }
  list.innerHTML = str;

// 今回の交差を監視する要素
  const boxes = document.querySelectorAll(".box");
  const options = {
    root: null,
    rootMargin: "-30% 0px -70%",
    threshold: 0
  };
  const observer = new IntersectionObserver(doWhenIntersect, options);
  boxes.forEach(box => {
    observer.observe(box);
  });

  /**
  * 交差したときに呼び出す関数
  */
  function doWhenIntersect(entries) {
    // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        activateIndex(entry.target);
      } else {
        if(entry.boundingClientRect.y > 0 && entry.target.id === 'index1') {
          const currentActiveIndex = document.querySelector("#indexList .active");
          // すでにアクティブになっているものが0個の時（=null）以外は、activeクラスを除去
          if (currentActiveIndex !== null) {
            currentActiveIndex.classList.remove("active");
          }
        }
      }
    });
  }
  /**
  * 目次の色を変える関数
  */
  function activateIndex(element) {
    // すでにアクティブになっている目次を選択
    const currentActiveIndex = document.querySelector("#indexList .active");
    // すでにアクティブになっているものが0個の時（=null）以外は、activeクラスを除去
    if (currentActiveIndex !== null) {
      currentActiveIndex.classList.remove("active");
    }
    // 引数で渡されたDOMが飛び先のaタグを選択し、activeクラスを付与
    const newActiveIndex = document.querySelector(
      `a[href='#${element.id}']`
    );
    newActiveIndex.classList.add("active");
  }
}());